import { render } from "./ArtistList.vue?vue&type=template&id=05981dca&scoped=true"
import script from "./ArtistList.vue?vue&type=script&lang=js"
export * from "./ArtistList.vue?vue&type=script&lang=js"

import "./ArtistList.vue?vue&type=style&index=0&id=05981dca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05981dca"]])

export default __exports__